<template>
  <modal
    class="modal--search-widget modal--calendar"
    :class="{
      'model-calendar--flexible-days-animate': flexibleDaysAnimate,
      'model-calendar--date-inputs-hidden': !showDateInputs,
    }"
    :title="translations.calendar_title"
    @close="close"
    :close-on-click="true"
    :is-open="mounted"
    :no-scroll="enableNoscroll"
  >
    <img src="./../../../img/icons/icon-calendar.svg" alt slot="icon" />
    <div>
      <data-range-picker 
        v-model="dateRange" 
        ref="rangepicker"
        :min-date="minDate"
        :showWeekNumbers="true"
        :timePicker="false"
        :ranges="false"
        :localeData="localeData"
        :flexibleStartDate="flexibleStartDate"
        :flexibleEndDate="flexibleEndDate"
        :autoApply="true"
        :opens="opens"
        >
        <div slot="input" slot-scope="picker" class="search-field search-dates" v-if="showDateInputs">
          <input-field
            name="departure"
            :readonly="true"
            icon-type="cal-start"
            :value="(picker.startDate) ? formatDate(picker.startDate, 'DD MMM', flexibleStartDays * -1) : ' '"
          ></input-field>
          <input-field
            name="arrival"
            :readonly="true"
            icon-type="cal-end"
            :value="(picker.endDate) ? formatDate(picker.endDate, 'DD MMM', flexibleEndDays) : ''"
          ></input-field>
        </div>        
      </data-range-picker>
      <div class="flexible-range-dropdowns">
        <div class="from-date" v-if="startDate">
          <h2 v-text="formatDate(startDate, 'ddd D. MMM')"></h2>
          <selector :options="startRange" :value="flexibleStartDays" @input="(val) => flexibleStartDays = parseInt(val)" iconType="drop-down"></selector>
        </div>
        <div class="to-date" v-if="endDate">
          <h2 v-text="formatDate(endDate, 'ddd D. MMM')"></h2>
          <selector :options="endRange" :value="flexibleEndDays" @input="(val) => flexibleEndDays = parseInt(val)" iconType="drop-down"></selector>
        </div>
      </div>
   

    </div>
    <div slot="footer" class="modal-view__footer">
      <button v-text="translations.ok_btn" class="btn btn--success" @click="close" :disabled="inSelection"></button>
    </div>
  </modal>
</template>

<script>
import DataRangePicker from "./DateRangePicker.vue";
import InputField from "../input-field.vue";
import Moment from "moment";
import Modal from "./../modal.vue";
import Selector from './../selector.vue';

export default {
  props: {
    value: { type: Object, default: null },
    useNoscroll: {type: Boolean, default: true},
    showDateInputs: {type: Boolean, default: true}
  },
  data() {
    let startDate = this.value.start ? this.value.start : "";
    let endDate = this.value.end ? this.value.end : "";
    let flexibleStartDays = this.value.flexibleStartDays || 0;
    let flexibleEndDays = this.value.flexibleEndDays || 0;

    return {
      translations: APP_CONFIG.TRANSLATION.SEARCH_WIDGET,
      dateRange: {
        startDate,
        endDate
      },
      flexibleStartDays,
      flexibleEndDays,
      mounted: false,
      flexibleDaysAnimate: false
    };
  },
  mounted() {
    this.mounted = true;
  },
  watch: {
    'dateRange.startDate'() {
      this.sendData();
    },
    'dateRange.endDate'() {
      this.sendData();
    },
    flexibleStartDays() {
      this.sendData();
    },
    flexibleEndDays() {
      this.sendData();
    }
  },
  methods: {
    enableFlexibleDates() {
      this.flexibleDaysAnimate = true;
      this.$nextTick(() => {
        this.flexibleStartDays = 5;
        this.flexibleEndDays = 5;
      })
    },
    close(evt) {
      this.$emit("close", evt);
    },
    formatDate(dateobj, format = 'DD MMM', flexibleDays = 0) {
      let date = Moment(dateobj).format(format);

      if(flexibleDays > 0) {
        date += ' +' + flexibleDays;
      } else if(flexibleDays < 0) {
        date += ' ' + flexibleDays;
      }

      return date;
    },
    sendData() {
      if(this.inSelection) {
        return;
      }
      
      this.$emit("input", {
        start: Moment(this.startDate),
        end: Moment(this.endDate),
        flexibleStartDays: this.flexibleStartDays,
        flexibleEndDays: this.flexibleEndDays
      });
    },
    getRange(sign = '') {
      let range = [ ];
      range.push({
        value: 0,
        text: 'Præcis dato'
      });

      for(let i = 1; i <= 10; i++) {
        range.push({
          text: sign + i + ' dag',
          value: i
        });
      }

      return range;
    }
  },
  computed: {
    enableNoscroll() {
      return !this.autoSave && this.useNoscroll ? true : false;
    },
    autoSave() {
      return window.innerWidth >= 900;
    },
    startDate() {
      return (this.mounted && this.$refs.rangepicker) ? this.$refs.rangepicker.start : null;
    },
    endDate() {
      return (this.mounted && this.$refs.rangepicker) ? this.$refs.rangepicker.end : null;
    },
    flexibleStartDate() {
      if(this.startDate && this.flexibleStartDays) {
        let startDate = Moment(this.startDate).clone();
        startDate = startDate.subtract(this.flexibleStartDays, 'days').toDate();
        startDate.setHours(0,0,0,0);
        return startDate;
      }

      return null;
    },
    startRange() {
      return this.getRange('-');
    },
    flexibleEndDate() {
      if(this.endDate && this.flexibleEndDays) {
        let endDate = Moment(this.endDate).clone();
        endDate = endDate.add(this.flexibleEndDays, 'days').toDate();
        endDate.setHours(0,0,0,0);
        return endDate;
      }

      return null;
    },
    endRange() {
      return this.getRange('+');
    },
    opens() {
      return (this.inSelection) ? 'right' : 'left';
    },
    inSelection() {
      return (this.mounted && this.$refs.rangepicker) ? this.$refs.rangepicker.in_selection : false;
    },
    minDate() {
      return Moment().toDate();
    },
    localeData() {
      return {
        direction: 'ltr',
        format: Moment.localeData().longDateFormat('L'),
        separator: ' - ',
        applyLabel: 'Apply',
        cancelLabel: 'Cancel',
        weekLabel: 'Uge',
        customRangeLabel: 'Custom Range',
        daysOfWeek: Moment.weekdaysMin(),
        monthNames: Moment.monthsShort(),
        firstDay: Moment.localeData().firstDayOfWeek()
      }
    }
  },
  components: {
    DataRangePicker,
    InputField,
    Modal,
    Selector
  }
};
</script>
